import React, { FC, useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { Button, Dropdown, Switch } from "antd";
import { useDispatch } from "react-redux";
import { ENCRYPT_TOKEN } from "reducers/authReducer";

import {
  CreateNewPageModal,
  UserStatusModal,
  CallLogsModal,
  CallBoxModal,
  IoTAlertTableModal,
  PeopleListModal,
  ProjectListModal,
  CustomerListModal,
} from "../../Modals";
import { MENU_ITEM_IDs, PAGE_TYPES } from "utils/PageTypes";
import AnalyticsVideoModal from "components/Modals/AnalyticsVideoModal";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { popupCenter } from "utils/appUtil";
import DraggableMenu from "./DraggableMenu";
import useLocalStorageService from "../../../services/localStorage";
import MenuItems from "./MenuItems";

const SideBar: FC<{
  socket?: ISocket;
  params: DashboardParams;
  onPageCreated?: () => void;
}> = ({ socket, params, onPageCreated }) => {
  const { screens, setScreens, setFirstCADVisible } = params;
  const [isCreateNewPageModalVisible, setIsCreateNewPageModalVisible] =
    useState<CreateNewPageModelObj>({
      visible: false,
      type: PAGE_TYPES.REGULAR,
    });
  const [isUserStatusModalVisible, setIsUserStatusModalVisible] =
    useState<boolean>(false);
  const [isCallLogsModalVisible, setIsCallLogsModalVisible] =
    useState<boolean>(false);
  const [isCallBoxModalVisible, setIsCallBoxModalVisible] =
    useState<boolean>(false);
  const [analyticsVideoModalDisplayed, setAnalyticsVideoModal] =
    useState<boolean>(false);
  const [peopleModalDisplayed, setPeopleModalDisplayed] =
    useState<boolean>(false);
  const [projectModalDisplayed, setProjectModalDisplayed] =
    useState<boolean>(false);
  const [customerModalDisplayed, setCustomerModalDisplayed] =
    useState<boolean>(false);
  const [isAlertTableModalVisible, setIsAlertTableModalVisible] =
    useState<boolean>(false);
  const [currentLocation, setCurrentLocation] = useState<CurrentLocation>();
  const { page_group, projects, adminRoles } = useSelector(
    (state: RootState) => state.dashboard
  );
  const { userInfo } = useSelector(
    (state: RootState) => state.auth
  );
  const [isMenuItemsOpen, setIsMenuItemsOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [selectedMenuItems, setSelectedMenuItems] = useState<MenuItems[]>([]);
  const [menuItems, setMenuItems] = useState<MenuItems[]>([]);
  const { getLocalStorageItem, setLocalStorageItem } = useLocalStorageService();

  const dispatch = useDispatch();

  useEffect(() => {
    if (page_group)
      setIsCreateNewPageModalVisible({ visible: true, type: PAGE_TYPES.GROUP });
  }, [page_group]);

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        console.log("set current location", position);
        setCurrentLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    getCurrentLocation();
  }, []);

  useEffect(() => {
    if (adminRoles && Array.isArray(adminRoles) && userInfo?.roleId) {
      const role = adminRoles?.find((x) => {
        return x._id === userInfo?.roleId;
      });


      console.log('admin rols', adminRoles);

      console.log('current user role', role);

      console.log('user info', userInfo);

      if (role?.permissions?.includes('admin')) {
        setIsAdmin(true);
      }
      else {
        setIsAdmin(false)
      }
    }
  }, [adminRoles, userInfo])

  const dashboardMenu = (
    <ul className="user-dropdown">
      <li
        onClick={() => {
          dispatch({
            type: "SET_SELECTED_ITEM",
            payload: { pageId: undefined },
          });
          setScreens({
            ...screens,
            iframe: true,
            iframeUrl: `${process.env.REACT_APP_SHARED_URI
              }/dashboard?userId=${localStorage.getItem(
                "RID"
              )}&connectionId=${localStorage.getItem("CID")}10`,
          });
        }}
      >
        <span className="ml-2">Embedded</span>
      </li>
      <li
        onClick={() => {
          window.open(
            `${process.env.REACT_APP_SHARED_URI
            }/dashboard?userId=${localStorage.getItem(
              "RID"
            )}&connectionId=${localStorage.getItem("CID")}11`,
            "_blank"
          );
        }}
      >
        <span className="ml-2">New window</span>
      </li>
    </ul>
  );

  const OverlayMenus = { dashboard: dashboardMenu };
  const MENU_ITEMS: MenuItems[] = [
    {
      id: MENU_ITEM_IDs.Broadcast,
      key: "broadcast",
      name: "Broadcast",
      src: "/images/broadcast-icon.svg",
      onClick: () =>
        setIsCreateNewPageModalVisible({
          visible: true,
          type: PAGE_TYPES.BROADCAST,
        }),
    },
    {
      id: MENU_ITEM_IDs.Ai,
      key: "ai",
      name: "AI page",
      src: "/images/camera-icon.svg",
      cssClass: "grey-icon",
      onClick: () =>
        setIsCreateNewPageModalVisible({
          visible: true,
          type: PAGE_TYPES.AI,
        }),
    },
    {
      id: MENU_ITEM_IDs.IoT,
      key: "iot",
      name: "IoT page",
      src: "/images/iot-icon.svg",
      cssClass: "grey-icon",
      onClick: () =>
        setIsCreateNewPageModalVisible({
          visible: true,
          type: PAGE_TYPES.IOT,
        }),
    },
    {
      id: MENU_ITEM_IDs.First,
      key: "first",
      name: "First",
      src: "/images/emergency-icon.svg",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                cudbServiceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/911?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.EventCreator,
      key: "eventCreator",
      name: "Event creator",
      src: "/images/clock-icon.svg",
      onClick: () => {
        if (projects?.defaultCPC) {
          window.open(
            `https://cpc.staging.beam.live/c/${projects?.defaultCPC}?serviceId=${projects?.userServiceId}&adminUserId=${projects?.adminUserId}&connectionId=${localStorage.getItem("CID")}`,
            "_blank"
          );
        }
        else {
          dispatch(
            ENCRYPT_TOKEN({
              data: {
                payload: JSON.stringify({
                  userId: localStorage.getItem("RID"),
                  connectionId: `${localStorage.getItem("CID")}`,
                  cudbServiceId: projects?.userServiceId,
                }),
              },
              callback: (token) => {
                window.open(
                  `${process.env.REACT_APP_SHARED_URI}/cpc?token=${token.encryptedPayload}`,
                  "_blank"
                );
              },
            })
          );
        }
      },
    },
    {
      id: MENU_ITEM_IDs.ProjectEventCreator,
      key: "projectEventCreator",
      name: "Project event creator",
      src: "/images/clock-icon.svg",
      onClick: () => {
        setProjectModalDisplayed(true);
      },
    },
    {
      id: MENU_ITEM_IDs.CallCenter,
      key: "callCentre",
      name: "Call center",
      src: "/images/call-icon.svg",
      cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                cudbServiceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/call-center?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Friends,
      key: "friend",
      name: "Friends",
      src: "/images/community-icon.svg",
      onClick: () => {
        setPeopleModalDisplayed(true);
      },
    },
    {
      id: MENU_ITEM_IDs.Ride,
      key: "ride",
      name: "Ride",
      src: "/images/ride-dispatch-icon.svg",
      cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/ride2?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Shuttle,
      key: "shuttle",
      name: "Shuttle",
      src: "/images/ride-dispatch-icon.svg",
      cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/shuttle2?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Lighthouse,
      key: "lighthouse",
      name: "Lighthouse",
      src: "/images/clock-icon.svg",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                cudbServiceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/lighthouse?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Video,
      key: "video",
      name: "Video",
      src: "/images/media-icon.svg",
      onClick: () => {
        setAnalyticsVideoModal(true);
      },
    },
    {
      id: MENU_ITEM_IDs.Admin,
      key: "admin",
      name: "Admin",
      src: "/images/setting-icon.svg",
      cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                cudbServiceId: projects?.userServiceId,
                configUserId: projects?.adminUserId,
              }),
            },
            callback: (token) => {
              window.location.href = `${process.env.REACT_APP_ADMIN_API}?token=${token.encryptedPayload}`;
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.School,
      key: "school",
      name: "School bus",
      src: "/images/ride-dispatch-icon.svg",
      cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/school?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.School2,
      key: "school2",
      name: "School",
      src: "/images/desktop-icon.svg",
      // cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/school2?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Coach,
      key: "sports",
      name: "Sports",
      src: "/images/community-icon.svg",
      cssClass: "",
      onClick: () => {
        // window.open(
        //   `${process.env.REACT_APP_SHARED_URI}/coach?adminUserId=${projects?.adminUserId
        //   }&serviceId=${projects?.userServiceId
        //   }&connectionId=${localStorage.getItem("CID")}`,
        //   "_blank"
        // );

        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
                adminUserId: projects?.adminUserId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/sports?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );

      },
    },
    {
      id: MENU_ITEM_IDs.Medical,
      key: "medical",
      name: "Medical",
      src: "/images/heart-icon.svg",
      cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/medical?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Coupon,
      key: "coupon",
      name: "Coupon",
      src: "/images/media-icon.svg",
      // cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/coupon?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Fleet,
      key: "fleet",
      name: "Fleet",
      src: "/images/car-icon.svg",
      // cssClass: "settings-icon",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/fleet?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.CFO,
      key: "cfo",
      name: "CFO",
      src: "/images/community-icon.svg",
      onClick: () => {
        dispatch(
          ENCRYPT_TOKEN({
            data: {
              payload: JSON.stringify({
                userId: localStorage.getItem("RID"),
                connectionId: `${localStorage.getItem("CID")}`,
                serviceId: projects?.userServiceId,
                adminUserId: projects?.adminUserId,
              }),
            },
            callback: (token) => {
              window.open(
                `${process.env.REACT_APP_SHARED_URI}/cfo?token=${token.encryptedPayload}`,
                "_blank"
              );
            },
          })
        );
      },
    },
    {
      id: MENU_ITEM_IDs.Customer,
      key: "customer",
      name: "Customer",
      src: "/images/customer.svg",
      cssClass: "grey-icon",
      onClick: () => {
        setCustomerModalDisplayed(true);
      },
    },
  ];

  const onTogglePin = (item) => {
    let items = [];
    if (item.pinned) {
      items = [...selectedMenuItems, item];
      setSelectedMenuItems(items);
    } else {
      items = selectedMenuItems.filter((x) => x.id !== item.id);
      setSelectedMenuItems(items);
    }
    setLocalStorageItem("selectedMenuItems", items);
  };

  const onDrag = (items: MenuItems[]) => {
    setSelectedMenuItems(items.filter((x) => x.pinned));
  };

  useEffect(() => {
    let _selectedMenuItems =
      JSON.parse(getLocalStorageItem("selectedMenuItems")) || [];
    let selectedItems = [];
    let allItems = MENU_ITEMS;
    // if(projects?.webSettings){
    //   allItems = allItems.filter(item => projects?.webSettings?.[item.key]);
    // }
    _selectedMenuItems.forEach((element) => {
      let index = allItems.findIndex((x) => x.id == element.id);
      if (index !== -1) {
        allItems[index].pinned = true;
        selectedItems.push(allItems[index]);
      }
    });
    setSelectedMenuItems(allItems.filter((x) => x.pinned));
    setMenuItems(allItems);
  }, [projects]);

  return (
    <div className="sidebar">
      <ul>
        <li className="mb-5">
          <ReactSVG
            src="/images/plus-icon.svg"
            onClick={() =>
              setIsCreateNewPageModalVisible({
                visible: true,
                type: PAGE_TYPES.REGULAR,
              })
            }
          />
          <p>New</p>
          {isCreateNewPageModalVisible.visible && (
            <CreateNewPageModal
              currentLocation={currentLocation}
              socket={socket}
              isModalVisible={isCreateNewPageModalVisible}
              setIsModalVisible={setIsCreateNewPageModalVisible}
              onCreated={() => onPageCreated && onPageCreated()}
            />
          )}
        </li>
        {selectedMenuItems?.length > 0 &&
          selectedMenuItems.filter((x) => {
            return x?.key !== 'admin' || (x?.key === 'admin' && isAdmin)
          }).map((item) => (
            <li key={"selected-" + item.id}>
              {item.isOverlay && (
                <div>
                  <Dropdown
                    overlay={OverlayMenus[item.overlay]}
                    placement="bottomRight"
                    trigger={["click"]}
                  >
                    <div>
                      <ReactSVG className={item.cssClass} src={item.src} />
                      <p>{item.name}</p>
                    </div>
                  </Dropdown>
                </div>
              )}

              {!item.isOverlay && (
                <div
                  onClick={() => {
                    const tempItem = MENU_ITEMS.find((x) => {
                      return x.id === item.id;
                    });
                    tempItem?.onClick();
                  }}
                >
                  <ReactSVG className={item.cssClass} src={item?.src} />
                  <p>{item?.name}</p>
                </div>
              )}
            </li>
          ))}
        <li onClick={() => setIsMenuItemsOpen(true)}>
          <img src="/images/down.png" />
          <p> More</p>
        </li>
      </ul>

      {isMenuItemsOpen && (
        <DraggableMenu
          onDrag={onDrag}
          onClose={() => setIsMenuItemsOpen(false)}
          onTogglePin={onTogglePin}
          items={menuItems?.filter((x) => { return x?.key !== 'admin' || (x?.key === 'admin' && isAdmin) })}
        />
      )}

      {isUserStatusModalVisible && (
        <UserStatusModal
          isModalVisible={isUserStatusModalVisible}
          setIsModalVisible={setIsUserStatusModalVisible}
        />
      )}
      {isCallLogsModalVisible && (
        <CallLogsModal
          isModalVisible={isCallLogsModalVisible}
          setIsModalVisible={setIsCallLogsModalVisible}
        />
      )}
      {isCallBoxModalVisible && (
        <CallBoxModal
          isModalVisible={isCallBoxModalVisible}
          setIsModalVisible={setIsCallBoxModalVisible}
        />
      )}
      {analyticsVideoModalDisplayed && (
        <AnalyticsVideoModal onClose={() => setAnalyticsVideoModal(false)} />
      )}
      {peopleModalDisplayed && (
        <PeopleListModal
          onClose={() => setPeopleModalDisplayed(false)}
          socket={socket}
        />
      )}

      {projectModalDisplayed && (
        <ProjectListModal
          onClose={() => setProjectModalDisplayed(false)}
          socket={socket}
        />
      )}

      {customerModalDisplayed && (
        <CustomerListModal
          onClose={() => setCustomerModalDisplayed(false)}
          socket={socket}
        />
      )}

      {isAlertTableModalVisible && (
        <IoTAlertTableModal
          onClose={() => setIsAlertTableModalVisible(false)}
        />
      )}
    </div>
  );
};

export default SideBar;
